import React, { FC } from "react";
import "./ErrorPage.style.css";

export const ErrorPage: FC = () => {
  return (
    <div className="errorpage-content">
      <p>Oops...Someting went wrong. It happens to the best of us;)</p>
    </div>
  );
};

export default ErrorPage;
